module.exports = __webpack_public_path__ + "static/img/bg.280f2435.png";